import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { trackEvent } from "../../services/amplitude";
import InfoLayout from "./InfoLayout";
import "../../styles/InfoPage.css";

export default function AboutPage() {
  const { t, i18n } = useTranslation("about");
  const trackedRef = useRef(false);

  useEffect(() => {
    if (trackedRef.current) return;
    trackedRef.current = true;

    trackEvent("info_page_opened", {
      page: "about",
      lang: i18n.language,
    });
  }, [i18n.language]);

  return (
    <InfoLayout title={t("title")}>
      <h2 className="infoH2">{t("heading1")}</h2>

      <p className="infoP">
        {t("text1")}
      </p>

      <h2 className="infoH2">{t("heading2")}</h2>

      <p className="infoP">
        {t("text2")}
      </p>

      <p className="infoP">
        {t("text3")}
      </p>
    </InfoLayout>
  );
}